module.exports = __webpack_public_path__ + "img/returnGameMiddle.c29ca06e.png";